import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseComponent } from 'app/com/ibm/tw/commons/mvc/base.component';
import { TxnService } from 'app/services/txn.service';
import { CommandButtonModule } from 'ui-components/button';
import { EventData, SharedModule } from 'ui-components/common';
import { MessagesModule } from 'ui-components/messages';
import { PopupModule } from 'ui-components/popup';
import { StringUtils } from '../../../com/ibm/tw/commons/utils/string.utils';
import { SuspendPopupViewForm } from './suspend.popup.viewfrom';


@Component({
    standalone: true,
    selector: 'suspend-popup',
    templateUrl: 'suspend.popup.component.html',
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        PopupModule,
        CommandButtonModule,
        MessagesModule
  ],
})
export class SuspendPopupComponent extends BaseComponent {

    @Input() display: boolean = false;

    @Input() viewForm: SuspendPopupViewForm;

    @Output() closeCallback = new EventEmitter();

    @Output() confirmCallback = new EventEmitter();

    /** 建構子 */
    constructor(public txnService: TxnService) {
        super(txnService);
    }

    onClose(event: EventData) {
        this.closeCallback.emit();
    }

    onShow() {
        if (StringUtils.isEmptyStr(this.viewForm.title)) {
            this.viewForm.title = this.txnService.transform('系統暫停', 'common00005044', null);
        }
    }

    onHide(event: EventData) {
        this.closeCallback.emit();
    }

    doConfirm(event: EventData): void {
        this.confirmCallback.emit(true);
    }


}
